import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {
  MatIconRegistry,
  SafeResourceUrlWithIconOptions
} from '@angular/material/icon';
import { NAV_ICONS, NavIconName, navIconSvg } from './nav-icons';

@Injectable({
  providedIn: 'root'
})
export class IconsService {
  constructor(
    private readonly domSanitizer: DomSanitizer,
    private readonly iconRegistry: MatIconRegistry
  ) {
    this.iconRegistry.addSvgIconResolver(
      (
        name: string,
        namespace: string
      ): SafeResourceUrl | SafeResourceUrlWithIconOptions | null => {
        switch (namespace) {
          case 'mat':
            // Material Design Icons — OUTLINED variant (DESIGN-SYSTEM.md §6).
            // jsDelivr CDN, full icon set. Paired with the outlined-first font
            // stack in styles.scss so svgIcon and ligature mat-icons match.
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `https://cdn.jsdelivr.net/npm/@material-design-icons/svg@0.14.13/outlined/${name}.svg`
            );

          case 'logo':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/logos/${name}.svg`
            );

          case 'flag':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/flags/${name}.svg`
            );

          default:
            return null;
        }
      }
    );

    // Glyphes de l'aside (DESIGN.md §6) : inline, donc disponibles au premier
    // rendu sans requête réseau.
    for (const name of Object.keys(NAV_ICONS) as NavIconName[]) {
      this.iconRegistry.addSvgIconLiteralInNamespace(
        'nav',
        name,
        this.domSanitizer.bypassSecurityTrustHtml(navIconSvg(name))
      );
    }
  }
}
